import ManageProductListing from './ManageProductListing';

export default ManageProductListing;
